import { EMapActions } from './types';
import { actionGenerator } from '../utils/actionGenerator';
import { IInfrastructureCategory, IInfrastructureItem } from 'shared/types/infrastructure';
import { ICoordinates } from '../types';
import { ERoutingMode, ILocation, IRouteInfo } from '../types/route';

export const openMap = actionGenerator<EMapActions.OpenMap>(EMapActions.OpenMap);

export const closeMap = actionGenerator<EMapActions.CloseMap>(EMapActions.CloseMap);

export const setCenter = actionGenerator<EMapActions.SetCenter, ICoordinates>(EMapActions.SetCenter);

export const openPanorama = actionGenerator<EMapActions.OpenPanorama>(EMapActions.OpenPanorama);

export const closePanorama = actionGenerator<EMapActions.ClosePanorama>(EMapActions.ClosePanorama);

export const setActiveInfrastructureCategory = actionGenerator<
  EMapActions.SetActiveInfrastructureCategory,
  string | undefined
>(EMapActions.SetActiveInfrastructureCategory);

export const setZoom = actionGenerator<EMapActions.SetZoom, number>(EMapActions.SetZoom);

export const setPanoramaError = actionGenerator<EMapActions.SetPanoramaError, boolean>(EMapActions.SetPanoramaError);

export const setInfrastructureCategories = actionGenerator<
  EMapActions.SetInfrastructureCategories,
  IInfrastructureCategory[]
>(EMapActions.SetInfrastructureCategories);

export const setActiveInfrastructureItem = actionGenerator<
  EMapActions.SetActiveInfrastructureItem,
  IInfrastructureItem | undefined
>(EMapActions.SetActiveInfrastructureItem);

export const activeRouteMode = actionGenerator<EMapActions.ActiveRouteMode>(EMapActions.ActiveRouteMode);

export const deactiveRouteMode = actionGenerator<EMapActions.DeactiveRouteMode>(EMapActions.DeactiveRouteMode);

export const openRouteSearchModal = actionGenerator<EMapActions.OpenRouteSearchModal>(EMapActions.OpenRouteSearchModal);

export const closeRouteSearchModal = actionGenerator<EMapActions.CloseRouteSearchModal>(
  EMapActions.CloseRouteSearchModal,
);

export const setLocation = actionGenerator<EMapActions.SetLocation, ILocation | null>(EMapActions.SetLocation);

export const setRouteFrom = actionGenerator<EMapActions.SetRouteFrom, ILocation | null>(EMapActions.SetRouteFrom);

export const setRouteTo = actionGenerator<EMapActions.SetRouteTo, ILocation | null>(EMapActions.SetRouteTo);

export const setRouteBuildingLoading = actionGenerator<EMapActions.SetRouteBuildingLoading>(
  EMapActions.SetRouteBuildingLoading,
);

export const setRouteBuildingSucceed = actionGenerator<EMapActions.SetRouteBuildingSucceed>(
  EMapActions.SetRouteBuildingSucceed,
);

export const setRouteBuildingFailed = actionGenerator<EMapActions.SetRouteBuildingFailed>(
  EMapActions.SetRouteBuildingFailed,
);

export const setRouteInfo = actionGenerator<EMapActions.SetRouteInfo, IRouteInfo>(EMapActions.SetRouteInfo);

export const setRoutingMode = actionGenerator<EMapActions.SetRoutingMode, ERoutingMode>(EMapActions.SetRoutingMode);

export const resetRoute = actionGenerator<EMapActions.ResetRoute>(EMapActions.ResetRoute);
